import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: ["rounded-md shadow-sm transition duration-150 my-2 sm:my-4", {
			[`bg-${_ctx.color}`]: true,
			'px-4': !_ctx.cardContents.content,
			'pb-4': !_ctx.cardContents.footer,
			'pt-4': !_ctx.cardContents.header,
		}]
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}